/**
 * tdesign v1.6.6
 * (c) 2023 tdesign
 * @license MIT
 */

import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { renderTNodeJSX } from '../utils/render-tnode.js';
import { getClassPrefixMixins } from '../config-provider/config-receiver.js';
import mixins from '../utils/mixins.js';
import '@babel/runtime/helpers/typeof';
import 'vue';
import '@vue/composition-api';
import 'lodash/camelCase';
import 'lodash/kebabCase';
import 'lodash/mergeWith';
import '../config-provider/context.js';
import 'lodash/merge';
import '../_common/js/global-config/default-config.js';
import '../_common/js/global-config/locale/zh_CN.js';
import '../_chunks/dep-fdafdce0.js';
import 'dayjs';
import '../_chunks/dep-9849f16c.js';
import '../config-provider/type.js';

var classPrefixMixins = getClassPrefixMixins("layout");
var _Layout = mixins(classPrefixMixins).extend({
  name: "TLayout",
  data: function data() {
    return {
      hasSider: false
    };
  },
  provide: function provide() {
    return {
      layout: this
    };
  },
  methods: {
    renderContent: function renderContent() {
      return this.$scopedSlots["default"] ? this.$scopedSlots["default"](null) : "";
    }
  },
  computed: {
    classes: function classes() {
      return [this.componentName, _defineProperty({}, "".concat(this.componentName, "--with-sider"), this.hasSider)];
    }
  },
  render: function render() {
    var h = arguments[0];
    return h("section", {
      "class": this.classes
    }, [renderTNodeJSX(this, "default")]);
  }
});

export { _Layout as default };
//# sourceMappingURL=layout.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/tdesign-vue/es/layout/layout.js
// module id = null
// module chunks = 